import * as React from 'react';
import '@style/component/loading/content-loading.less';

const Loading = require('@static/image/logo.png');

export const ContentLoading = () => {
  return (
    <div className="content-loading">
      <img src={Loading} />
    </div>
  );
};
